import Vue from 'vue'
import Router from 'vue-router'
import info from '../views/InfoEnter.vue'
import show from '../views/InfoShow.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
	  path: "/",
	  redirect:"/info"
    },
    {
      path: '/info',
      name: 'info',
      component: info 
    },
	{
	  path: '/show',
	  name: 'show',
	  component: show 
	}
  ]
})